export default function DashCollectionIcon() {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="32" height="32" rx="4" fill="#F2F5FF" />
        <path
          d="M9.125 11V21C9.125 21.3315 9.2567 21.6495 9.49112 21.8839C9.72554 22.1183 10.0435 22.25 10.375 22.25H22.875C23.0408 22.25 23.1997 22.1842 23.3169 22.0669C23.4342 21.9497 23.5 21.7908 23.5 21.625V12.875C23.5 12.7092 23.4342 12.5503 23.3169 12.4331C23.1997 12.3158 23.0408 12.25 22.875 12.25H10.375C10.0435 12.25 9.72554 12.1183 9.49112 11.8839C9.2567 11.6495 9.125 11.3315 9.125 11ZM9.125 11C9.125 10.6685 9.2567 10.3505 9.49112 10.1161C9.72554 9.8817 10.0435 9.75 10.375 9.75H21"
          stroke="#1B4DFF"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.0625 18.1875C20.5803 18.1875 21 17.7678 21 17.25C21 16.7322 20.5803 16.3125 20.0625 16.3125C19.5447 16.3125 19.125 16.7322 19.125 17.25C19.125 17.7678 19.5447 18.1875 20.0625 18.1875Z"
          fill="#1B4DFF"
          stroke="#1B4DFF"
          stroke-width="1.25"
        />
      </svg>
    </>
  );
}
